import React from 'react';
import './Event.css';

import { FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Event = (props) => {
    // Destrukturyzacja props�w
    const { id, image, date, title, place } = props;

    // Logika daty (zabezpieczona przed brakiem daty)
    let month = '';
    let year = '';
    if (date) {
        const parts = date.split(',');
        month = parts[0] ? parts[0].trim() : '';
        year = parts[1] ? parts[1].trim() : '';
    }

    return (
        <div className='event-item' key={id}>

            {/* Kontener zdj�cia */}
            <div className='image-container'>
                <img src={image} alt={title} />
            </div>

            {/* Nak�adka z tre�ci� */}
            <div className='content'>

                {/* Box z dat� w prawym g�rnym rogu */}
                <div className="date-badge">
                    <span className="month">{month}</span>
                    <span className="year">{year}</span>
                </div>

                {/* Dolna sekcja: Tytu� i Lokalizacja */}
                <div className="text-content">
                    {/* TYTU� (Link do szczeg��w wydarzenia) */}
                    <Link to={`/events/${id}`} className='main-heading'>
                        {title}
                    </Link>

                    {/* Lokalizacja */}
                    <div className='details'>
                        <h3>
                            <FaMapMarkerAlt className='icon' />
                            <span>{place}</span>
                        </h3>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Event;